module.exports = __webpack_public_path__ + "static/media/kubernetes.1d5c5809.png";